module.exports = __webpack_public_path__ + "static/media/tipic.359521b9.jpg";